import React from 'react';

import Image from 'components/Image';
import Typography from 'components/Typography';
import { DesignerDetail } from 'types/Designer';
import styles from './DesignerCard.module.css';

export type DesignerCardProps = {
  designer: DesignerDetail;
};

/** A simple DesignerCard that can behave as a link or button  */
const DesignerCard: React.FCWithChildren<DesignerCardProps> = ({ designer }) => {
  const { firstname, lastname, years, featured_image } = designer;
  const name = `${firstname} ${lastname}`;

  return (
    <div>
      <Image src={featured_image || ''} alt={name} aspectRatio="letterbox-portrait" />
      <div className={styles.text}>
        <Typography variant="tiny" uppercase block>
          {name}
        </Typography>
        {years && (
          <Typography variant="tiny" color="faded" uppercase>
            {years}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default DesignerCard;
